export function createLadderBlockers(scene, environmentLayer, map) {
  scene.ladderBlockers = scene.add.group();

  environmentLayer.forEachTile(tile => {
    if (!tile.properties?.topLadder) return;

    // Search downward for the row where adjacent tiles are solid — that's the floor gap.
    // If none found (freestanding ladder), place blocker at the top of the topLadder tile.
    let gapY = null;
    for (let dy = 0; dy <= 8; dy++) {
      const left  = environmentLayer.getTileAt(tile.x - 1, tile.y + dy);
      const right = environmentLayer.getTileAt(tile.x + 1, tile.y + dy);
      if (left?.properties?.collides || right?.properties?.collides) {
        gapY = (tile.y + dy) * tile.height;
        break;
      }
    }

    const cx = tile.pixelX + tile.width / 2;
    const by = gapY !== null ? gapY + 1 : tile.pixelY + 1;
    const blocker = scene.add.rectangle(cx, by, tile.width, 2, 0x000000, 0);
    scene.physics.add.existing(blocker, true);
    scene.ladderBlockers.add(blocker);
  }, scene, 0, 0, map.width, map.height);

  scene.physics.add.collider(scene.player, scene.ladderBlockers, null, (player, _blocker) => {
    if (scene.player.isClimbing || scene.inputKeys.down.isDown) return false;
    if (player.body.velocity.y < 0) return false; // going up — always pass through
    return true;
  }, scene);
}
